import { Dispatch, SetStateAction } from 'react';

import { ProductType } from '@mfe/shared/schema-types';

export type AddonsGridItemType = {
  kind: string;
  title: string;
  badgeText?: string;
  oldPrice?: number;
  price?: number;
  promotions: Array<AddonPromotion>;
  description: string;
  button: {
    text: string;
    onClick?: () => void;
    disabled?: boolean;
  };
  totalPromotionDuration?: number;
  isGroupedProduct: boolean;
};

export type AddonPromotion = {
  name: string;
  amount: number;
};

export type StepInstanceProps = {
  isOpen: boolean;
  openStep: number;
  setOpenStep: Dispatch<SetStateAction<number>>;
};

export enum CountryCode {
  US = 'US',
}

export interface CartProps extends CollapsibleCartProps {
  addon: ProductType;
  selectedEasyCareProduct?: ProductType | null;
  displayTC?: boolean;
  isLastStep?: boolean;
}

export type CollapsibleCartProps = {
  submitButtonLabel: string;
  isSubmitDisabled?: boolean;
  handleClick: () => void;
  displayTC?: boolean;
  isLastStep?: boolean;
};

export type GetPriceAndDiscountResult = {
  price: number;
  oldPrice?: number;
  promotions?: Array<AddonPromotion>;
  totalPromotionDuration?: number;
};

// TODO: move this to constants
export const YES = 'yes';
